import type { ReactNode } from 'react';
import { GraphQLProvider } from './ApolloProvider';

export interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return <GraphQLProvider>{children}</GraphQLProvider>;
}
